module.exports = __webpack_public_path__ + "static/img/stay-option-icon-oceanview.f4d222b8.svg";